/* eslint-disable prefer-destructuring */

/**
=========================================================
* Material Dashboard 3 PRO React - v2.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function item(theme, ownerState) {
  const { palette, borders, functions, transitions } = theme;
  const { active, color, transparentSidenav, whiteSidenav, darkMode } =
    ownerState;

  const { transparent, white, grey } = palette;
  const { borderRadius } = borders;
  const { rgba } = functions;

  return {
    pl: "8px",
    mt: 0.375,
    mb: 0.3,
    pb: "3px",
    pt: "3px",
    width: "100%",
    borderRadius: borderRadius.md,
    cursor: "pointer",

    transition: transitions.create("background-color", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.sharp,
    }),

    backgroundColor: active ? "#ffffff" : "transparent", // highlight if active
    "&:hover, &:focus": {
      backgroundColor: "#ffffff",
    },

  };
}

function itemContent(theme, ownerState) {
  const { palette, typography, transitions, functions } = theme;
  const {
    miniSidenav,
    name,
    active,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    icon,
  } = ownerState;

  const { white, dark } = palette;
  const { size, fontWeightRegular, fontWeightLight } = typography;
  const { pxToRem } = functions;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: `${pxToRem(8)} ${pxToRem(12)}`,
    marginLeft: pxToRem(26),
    userSelect: "none",
    position: "relative",

    "& span": {
      color: active ? "#000000" : "#ffffff",// White text by default
      fontWeight: fontWeightRegular,
      fontSize: size.xs,
      transition: "color 0.3s",
      whiteSpace: "normal",     // ⬅ text wraps normally
      wordBreak: "break-word",  // ⬅ breaks long words
      lineHeight: 1.4,          // ⬅ better spacing for 2 lines
      display: "block",         // ⬅ ensures it can expand to 2 lines
      marginLeft: pxToRem(18),
    },

    "&:hover span": {
      color: "#000000", // Black text on hover
    },


    "&::before": {

      content: () => {
        if (name === "Hub") return '"\\e30a"';
        if (name === "Care Coordinator Profiles") return '"\\f0e2"';
        if (name === "Patient Profiles") return '"\\e7fd"';
        if (name === "Doctors") return '"\\e7fe"';

        if (name === "Device Details") return '"\\e30a"';
        if (name === "My Readings") return '"\\e85c"'; // assessment (reports-style)
        if (name === "Device Inventory") return '"\\e30a"';

        if (name === "Dashboard") return '"\\e871"'; // Devices icon Unicode
        if (name === "Dealers") return '"\\e7fb"'; // People icon Unicode
        if (name === "Reports") return '"\\e873"';
        if (name === "Device Type") return '"\\e30d"';
        if (name === "Location") return '"\\e55f"';
        if (name === "Customer Type") return '"\\e7fd"';
        if (name === "Farmers") return '"\\f205"';
        if (name === "Customer Details") return '"\\e7fd"';

        if (name === "Customers") return '"\\e7fd"';
        if (name === "Admin") return '"\\e7fb"';
        if (name === "Inventory") return '"\\e179"';
        console.log("Rendering icon for:", name);
        if (name === "Performa Bills") return '"\\e558"'; // example icon
        if (name === "Credit Note") return '"\\e850"';
        if (name === "Debit Note") return '"\\e8b0"';
        if (name === "Quotation") return '"\\e8d1"';
        if (name === "Purchase Order") return '"\\e8cc"';
        if (name === "Goods Received") return '"\\e1a1"';
        if (name === "Inhouse") return '"\\e88a"';
        if (name === "Vendor Details") return '"\\e8d1"';
        if (name === "Invoice") return '"\\e8b0"';
        if (name === "Bill") return '"\\ef5b"';
        if (name === "SMTP Configuration") return '"\\e0be"';
        if (name === "Doctor Profiles") return '"\\e7fc"';
        if (name === "Patient–Doctor Assignment") return '"\ue250"';
        if (name === "Patient–Device Association") return '"\\e326"';
        if (name === "Device Data") return '"\\f8ee"';
        if (name === "Hospital Profiles") return '"\\e548"';    // Developer board icon Unicode
        if (name === "Duty & Rendering Allocation") return '"\ue250"';
        if (name === "Hospital Doctor") return '"\\f109"';    // Developer board icon Unicode
        if (name === "Notification Details") return '"\ue7f4"';
        if (name === "SOS Notifications") return '"\ue002"';
        if (name === "Alert Review Details") return '"\\e3f4"'; 
        if (name === "Critical Notifications") return '"\ue7f4"';
        if (name === "My Prescription") return '"\\e8f8"'; 
        if (name === "SnapMeal") return '"\\e57a"'; 
if (name === "Post Consultation") return '"\\e85d"'; // Event Noteif (name === "Alert Review Details") return '"\\e3f4"'; 
if (name === "Case Review Details") return '"\\e3f4"'; 
if (name === "Progress Notes") return '"\\e873"'; // Note icon
if (name === "Escalated Case") return  '"\ue7f4"'; 
        return '""'; // Default empty content


      },

      fontFamily: "'Material Icons'",
      fontSize: pxToRem(20),
      color: active ? "#000000" : "#ffffff", // White icon by default
      display: "flex",
      alignItems: "center",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      left: pxToRem(0),
      transition: "color 0.3s",
    },

    "&:hover::before": {
      color: "#000000", // Black icon on hover
    },
  };
}
function itemArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme;
  const {
    noCollapse,
    transparentSidenav,
    whiteSidenav,
    miniSidenav,
    open,
    active,
    darkMode,
  } = ownerState;

  const { white, dark } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: ownerState.open ? "rotate(0)" : "rotate(-180deg)",
    color: "#ffffff", // White arrow by default
    transition: transitions.create(["color", "transform", "opacity"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    "&:hover": {
      color: "#000000", // Black arrow on hover
    },

    [breakpoints.up("xl")]: {
      display:
        ownerState.noCollapse || ownerState.miniSidenav
          ? "none !important"
          : "block !important",
    },
  };
}

export { item, itemContent, itemArrow };
